/**
 * Csv Schema of RastreamentoHistorico
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {RastreamentoHistorico} from '@/model/resource/RastreamentoHistorico'

/* TODO: review generated schema */
export class CsvRastreamentoHistoricoSchema extends Schema {
  readonly name = 'CsvRastreamentoHistorico'

  readonly fieldSet: FieldSet<RastreamentoHistorico> = {
    idRastreamentoHistoricoPk: schema => schema.model.idRastreamentoHistoricoPk,
    rastreamento: schema => schema.model.rastreamento?.$id ?? null,
    latitude: schema => schema.model.latitude,
    longitude: schema => schema.model.longitude,
    dataPosicao: schema => Helper.datetime(schema.model.dataPosicao),
    statusCarga: schema => schema.model.statusCarga,
    idExterno: schema => schema.model.idExterno,
  }
}
